import $ from "jquery";

$(document).ready(function(){
  $('.form-input').mask('(000) 000-0000');
});
